import React from "react";
import { Link } from "react-router-dom";
import { Ban } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center relative z-10">
      <div className="card p-10" data-testid="payment-cancel">
        <Ban className="w-14 h-14 text-yellow-400 mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold">Pembayaran Dibatalkan</h1>
        <p className="text-slate-400 text-sm mt-2">Tidak ada dana yang terpotong. Anda bisa mencoba lagi kapan saja.</p>
        <Link to="/newsletter" className="btn-primary mt-6 inline-flex" data-testid="back-to-newsletter">Kembali ke Newsletter</Link>
      </div>
    </div>
  );
}
